// components/SelectionDialog.jsx
import React from 'react';

const SelectionDialog = ({ 
  open, 
  onClose, 
  title = "Select Action",
  message,
  options = []
}) => {
  if (!open) return null;

  return (
    <div style={overlay}>
      <div style={dialog}>
        <h3 style={dialogTitle} className='poppin'>{title}</h3>
        {message && <p style={dialogMessage}>{message}</p>}
        
        <div style={optionsContainer}>
          {options.map((option, index) => (
            <button
              key={index}
              onClick={() => {
                option.onClick();
                onClose();
              }}
              style={{
                ...optionStyle,
                ...(option.variant === 'danger' ? dangerButton : {}),
                ...(option.variant === 'primary' ? primaryButton : {}),
                ...(option.variant === 'success' ? successButton : {}),
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
        
        <button 
          onClick={onClose} 
          style={cancelButton}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.3)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const dialog = {
  background: "#fff",
  padding: "24px",
  borderRadius: "12px",
  minWidth: "320px",
  maxWidth: "400px",
  boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
};

const dialogTitle = {
  margin: "0 0 12px 0",
  fontSize: "18px",
  fontWeight: "600",
  color: "#333",
};

const dialogMessage = {
  margin: "0 0 20px 0",
  fontSize: "14px",
  color: "#666",
  lineHeight: "1.5",
};

const optionsContainer = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginBottom: "20px",
};

const optionStyle = {
  padding: "12px 16px",
  border: "none",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: "500",
  cursor: "pointer",
  transition: "all 0.2s ease",
};

const primaryButton = {
  background: "#3b82f6",
  color: "white",
};

const dangerButton = {
  background: "#ef4444",
  color: "white",
};

const successButton = {
  background: "#10b981",
  color: "white",
};

const cancelButton = {
  width: "100%",
  padding: "10px 16px",
  background: "#f3f4f6",
  color: "#374151",
  border: "none",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: "500",
  cursor: "pointer",
  transition: "all 0.2s ease",
};

export default SelectionDialog;